// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__Lp7TE","shareEmailBtn":"EmailShare_shareEmailBtn__mN14D","emailSvg":"EmailShare_emailSvg__GuX1t"};